import { useStyles } from '@signavio/ui';
import ContextHelp from '../ContextHelp';
import Markdown from '../Markdown';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Label = ({
  children,
  description,
  title,
  htmlFor,
  inline
}) => {
  // Warning unusual nesting structure
  // 1. If the input is taller than 40px, the label stays at the top
  // 2. If the label is not taller than the input, and the input is 40px tall, it will be centered vertically
  // 3. If the label is taller than the input, but the input is 40px, the label stay at the top
  // The inner most span is there so that the <ContextHelp /> is shown inline
  const styles = useStyles(labelStyles, {}, {
    '&inline': Boolean(inline)
  });
  return /*#__PURE__*/_jsx("label", {
    ...styles('wrapper'),
    "data-testid": "label",
    title: title || undefined,
    htmlFor: htmlFor,
    children: /*#__PURE__*/_jsx("div", {
      ...styles,
      children: /*#__PURE__*/_jsxs("div", {
        ...styles('content'),
        children: [children, typeof description === 'string' && description.length > 0 ? /*#__PURE__*/_jsx(ContextHelp, {
          children: /*#__PURE__*/_jsx(Markdown, {
            children: description
          })
        }) : description]
      })
    })
  });
};
const labelStyles = ({
  font
}) => ({
  // ie11 doesn't align-items center when the container has a  min-height
  // https://github.com/philipwalton/flexbugs/issues/231
  wrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  content: {
    width: '100%'
  },
  wordWrap: 'break-word',
  lineHeight: font.body.lineHeight,
  fontSize: font.body.fontSize,
  minHeight: 40,
  display: 'flex',
  alignItems: 'center',
  '&inline': {
    minHeight: null
  }
});
export default Label;